export default __webpack_public_path__ + "static/media/cancel-circle.8139ea34.svg";